var _circle, _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 149,
    viewBox: "0 0 149 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74.1083,
    cy: 74.1083,
    r: 73.1083,
    fill: "url(#paint0_linear_2_76)",
    stroke: "url(#paint1_linear_2_76)",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_76",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 41,
    width: 149,
    height: 108
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.217 74.1084C148.217 115.037 115.037 148.217 74.1083 148.217C33.1794 148.217 0 115.037 0 74.1084C0 33.1795 27.5271 42.7066 68.456 42.7066C109.385 42.7066 148.217 33.1795 148.217 74.1084Z",
    fill: "url(#paint2_linear_2_76)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_76)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2_76)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.155 209.764C187.155 239.594 162.973 263.775 133.144 263.775C132.934 263.775 132.725 263.774 132.516 263.772V263.775H-57.1509L-57.1485 263.772C-57.3585 263.774 -57.5687 263.776 -57.7792 263.776C-87.6087 263.776 -111.79 239.594 -111.79 209.765C-111.79 179.935 -87.6087 155.754 -57.7792 155.754C-32.0671 155.754 -10.5513 173.72 -5.10152 197.784L13.1892 174.594L70.3405 155.753H132.516V155.757C132.725 155.754 132.934 155.753 133.144 155.753C162.973 155.753 187.155 179.935 187.155 209.764Z",
    fill: "#E18700"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2_76",
    x: -125.79,
    y: 141.753,
    width: 326.945,
    height: 136.023,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_2_76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_76",
    x1: 74.1083,
    y1: 0,
    x2: 74.1083,
    y2: 148.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_76",
    x1: 74.1083,
    y1: 0,
    x2: 74.1083,
    y2: 148.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_76",
    x1: 74.1083,
    y1: 0.000135893,
    x2: 74.1083,
    y2: 148.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.eb892a14981fed173d9d59902a87fa05.svg";
export { ForwardRef as ReactComponent };